var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGearStick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_3019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4581 14H2.54193C1.69035 14 1 14.7496 1 15.6742C1 15.8542 1.13434 16 1.30003 16H14.7C14.8657 16 15 15.8541 15 15.6742C15 14.7496 14.3097 14 13.4581 14Z",
    fill: "#0473EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.31131 13H12.6887C12.8606 13 13 12.8541 13 12.6742C13 11.7496 12.2837 11 11.4001 11H4.59989C3.7163 11 3 11.7496 3 12.6742C3 12.8542 3.13936 13 3.31131 13Z",
    fill: "#0473EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30084 10H10.6992C10.8654 10 11 9.87223 11 9.71465C11 8.90473 10.3079 8.24816 9.45424 8.24816H8.50481V5.65762H9.38331C9.62046 5.65762 9.82061 5.49027 9.85036 5.26704C9.91053 4.81605 10.1499 2.72518 10.2094 2.2796C10.2887 1.68607 10.1102 1.13509 9.69334 0.686238C9.29715 0.259691 8.74043 0.0125171 8.14102 0.000576776C7.47341 -0.0127333 6.82174 0.203979 6.3738 0.686119C5.95687 1.13488 5.77834 1.6858 5.85753 2.27928C5.91647 2.72098 6.15635 4.81218 6.21728 5.26728C6.24715 5.49039 6.44724 5.65762 6.6843 5.65762H7.5632V8.24816H6.54576C5.69206 8.24816 5 8.90473 5 9.71465C5.00006 9.87226 5.13471 10 5.30084 10Z",
    fill: "#0473EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_3019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearStick);
export default __webpack_public_path__ + "static/media/gear-stick.ff49fc818452f7cbd7969cf3e334c2a9.svg";
export { ForwardRef as ReactComponent };